import { Mail, MapPin } from "lucide-react";
import { ParallaxImage, ParallaxText, ScrollFadeIn } from "@/components/Parallax";

export default function ContactoSection() {
  return (
    <section id="contacto" data-testid="contacto-section" className="py-24 md:py-32 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image with parallax */}
          <ScrollFadeIn direction="left" delay={0}>
            <ParallaxImage
              src="/images/escultura.png"
              alt="Recepción oficina Calle & Cía."
              className="grayscale-img"
              containerClassName="w-full h-[350px] lg:h-[500px] rounded-sm shadow-2xl"
              speed={0.3}
              scale={0.8}
            />
          </ScrollFadeIn>

          {/* Content */}
          <div className="relative z-10">
            <ParallaxText speed={-0.1}>
              <ScrollFadeIn direction="right" delay={0}>
                <p className="text-calle-primary-50 text-xs uppercase tracking-[0.3em] mb-4 font-semibold font-body">
                  Evaluemos su cartera
                </p>
              </ScrollFadeIn>
              <ScrollFadeIn direction="right" delay={0.1}>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-calle-primary leading-[1.1] tracking-[-0.01em] mb-6">
                  Contacto
                </h2>
              </ScrollFadeIn>
              <ScrollFadeIn direction="right" delay={0.15}>
                <div className="calle-underline mb-8"></div>
              </ScrollFadeIn>
              <ScrollFadeIn direction="right" delay={0.2}>
                <p className="text-gray-600 text-base leading-relaxed mb-10 font-body">
                  Si su institución requiere apoyo en recuperación judicial de créditos morosos, puede contactarnos a través del siguiente email. Revisaremos su consulta de forma reservada y nos comunicaremos a la brevedad.
                </p>
              </ScrollFadeIn>
            </ParallaxText>

            <ParallaxText speed={-0.05}>
              <ScrollFadeIn direction="up" delay={0.25}>
                <div className="bg-white p-8 rounded-sm border border-gray-200 shadow-lg hover:shadow-xl transition-shadow duration-500">
                  <div className="space-y-6">
                    <div className="flex items-center gap-4 group">
                      <div className="w-14 h-14 rounded-sm bg-gray-100 flex items-center justify-center shrink-0 group-hover:bg-calle-primary/10 transition-all duration-500">
                        <MapPin className="h-6 w-6 text-calle-primary" />
                      </div>
                      <div className="text-left">
                        <p className="text-gray-500 text-sm font-body mb-1">Ubicación</p>
                        <p className="text-calle-primary font-medium font-body text-lg">Santiago, Chile</p>
                      </div>
                    </div>

                    <div className="w-full h-px bg-gray-200"></div>

                    <div className="flex items-center gap-4 group">
                      <div className="w-14 h-14 rounded-sm bg-calle-primary/10 flex items-center justify-center shrink-0 group-hover:bg-calle-primary transition-all duration-500">
                        <Mail className="h-6 w-6 text-calle-primary group-hover:text-white transition-colors duration-500" />
                      </div>
                      <div className="text-left">
                        <p className="text-gray-500 text-sm font-body mb-1">Email</p>
                        <a 
                          href="mailto:administracion@calleycia.cl" 
                          data-testid="contact-email"
                          className="text-calle-primary font-medium font-body text-lg hover:underline transition-all"
                        >
                          administracion@calleycia.cl
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollFadeIn>
            </ParallaxText>
          </div>
        </div>
      </div>
    </section>
  );
}
